import React, { FC } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { withSitecoreContext, Text, DateField } from '@sitecore-jss/sitecore-jss-react';
import useMediaQuery from '../../../../hooks/useMediaQuery';
import { CustomText } from '../../../@shared/customText';
import { NewsListingItemModel } from '../../models/newsListing.model';
import { TNewsListingItem } from '../../types/newsListing.types';
import { WithSitecoreContextProps } from '@sitecore-jss/sitecore-jss-react/types/enhancers/withSitecoreContext';
import ctaTypes from '../../../../enums/CTA.enums';
import RoutableSitecoreLink from '../../../@shared/routableSitecoreLink';
import CTA from '../../../@shared/CTA';
import Media from '../media';
import { BreakpointsInPx } from '../../../../constants/breakpoints.constants';
import useFormatDate from '../../../../hooks/useFormatDate';
import './styles.scss';

const NewsCard: FC<WithTranslation & WithSitecoreContextProps & TNewsListingItem> = (props) => {
  const { t } = props;
  const model = new NewsListingItemModel(props);
  const isEE = props.sitecoreContext?.pageEditing;
  const isWide = useMediaQuery(`(min-width: ${BreakpointsInPx['tbl-p']})`);
  const formattedDate = useFormatDate(model.newsDate);

  return (
    <div className="news-listing-card">
      {model.tag ? (
        <div className="news-listing-card__badge">
          <Text field={{ value: model.tag }} tag="p" />
        </div>
      ) : null}
      <Media
        desktopImage={model?.desktopImage}
        mobileImage={model?.mobileImage}
        isDesktop={isWide}
        useVideo={model?.useVideo}
        videoUrl={model?.video}
        defaultDesktopImage={model?.defaultBgDesktopImage}
        defaultMobileImage={model?.defaultBgMobileImage}
      />
      <div className="news-listing-card__border">
        {model?.newsDate && (
          <DateField
            field={{ value: model.newsDate }}
            tag="div"
            className="news-listing-card__text news-listing-card__date"
            render={() => formattedDate}
          />
        )}
        {model.title && (
          <CustomText tag="div" field={{ value: model.title }} className="news-listing-card__text news-listing-card__text--title" />
        )}
        {model.shortDescription && (
          <Text tag="div" field={{ value: model.shortDescription }} className="news-listing-card__text news-listing-card__text--content" />
        )}
        <div className="news-listing-card__button-wrapper">
          {isEE ? (
            <RoutableSitecoreLink
              className="news-listing-card__button btn-primary-orange"
              field={{
                value: {
                  href: model?.ctaLink,
                },
              }}
              target={model?.ctaLink}
            />
          ) : (
            model?.ctaLink && (
              <CTA
                type={ctaTypes.primaryOrange}
                href={model?.ctaLink}
                target={model?.ctaLink}
                extraClassName="news-listing-card__button btn-primary-orange"
              >
                {t('cnhi-readMore')}
              </CTA>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default withSitecoreContext()(withTranslation()(NewsCard));
